import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreVM, UISlice } from '../view-models';
import { generateId } from '../utils/utils';

const initialState: UISlice = {
  notificationOptions: null,
  dateFilter: '',
  isUILoading: true,
  isSidebarLoading: false,
  isResizing: false,
  selectedNodeId: '',
  JSONTemplates: [],
  sessionID: generateId(),
  lastPolicies: [],
  showFeedback: false,
  errorURL: '',
  errorJSON: {},
};

interface snackbarProps {
  type: string;
  msg?: string;
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    enqueueSnackbar: (state, { payload: { type, msg = '' } }: PayloadAction<snackbarProps>) => {
      state.notificationOptions = { id: generateId(), type, msg };
    },
    clearNotifications: (state) => {
      state.notificationOptions = null;
      state.isUILoading = true;
      state.isResizing = false;
    },
    setDateFilter: (state, { payload }: any) => {
      state.dateFilter = payload;
    },
    showUILoader: (state) => {
      state.isUILoading = true;
    },
    hideUILoader: (state) => {
      state.isUILoading = false;
    },
    showSidebarLoader: (state) => {
      state.isSidebarLoading = true;
    },
    hideSidebarLoader: (state) => {
      state.isSidebarLoading = false;
    },
    startResizing: (state) => {
      state.isResizing = true;
    },
    stopResizing: (state) => {
      state.isResizing = false;
    },
    setFeedbackComp: (state, { payload }) => {
      state.showFeedback = payload;
    },
    setSelectedNodeID: (state, { payload }) => {
      state.selectedNodeId = payload;
    },
    setJSONTemplates: (state, { payload }) => {
      state.JSONTemplates = payload;
    },
    setLastPolicies: (state, { payload }) => {
      state.lastPolicies = payload.slice();
    },
    setErrorUrl: (state, { payload }) => {
      state.errorURL = payload;
    },
    setErrorJSON: (state, { payload }) => {
      state.errorJSON = payload;
    },
  },
});

export const {
  enqueueSnackbar,
  clearNotifications,
  setDateFilter,
  showUILoader,
  hideUILoader,
  showSidebarLoader,
  hideSidebarLoader,
  startResizing,
  stopResizing,
  setSelectedNodeID,
  setJSONTemplates,
  setLastPolicies,
  setFeedbackComp,
  setErrorUrl,
  setErrorJSON,
} = uiSlice.actions;

export const submitJSONError = createAction<any>('xmlData/submitJSONError');
export const fetchTemplates = createAction('xmlData/fetchTemplates');
export const fetchTemplate = createAction<string>('xmlData/fetchTemplate');
export const selectNotificationOptions = (state: StoreVM) => state.ui.notificationOptions;
export const selectFilters = (state: StoreVM) => state.ui.dateFilter;
export const selectIsUILoading = (state: StoreVM) => state.ui.isUILoading;
export const selectIsSidebarLoading = (state: StoreVM) => state.ui.isSidebarLoading;
export const selectIsResizing = (state: StoreVM) => state.ui.isResizing;
export const selectSelectedNodeId = (state: StoreVM) => state.ui.selectedNodeId;
export const getJSONTemplates = (state: StoreVM) => state.ui.JSONTemplates;
export const getSessionId = (state: StoreVM) => state.ui.sessionID;
export const getLastPolicies = (state: StoreVM) => state.ui.lastPolicies;
export const getFeedbackComp = (state: StoreVM) => state.ui.showFeedback;
export const getURLError = (state: StoreVM) => state.ui.errorURL;
export const getErrorJSON = (state: StoreVM) => state.ui.errorJSON;
export const { reducer: uiReducer } = uiSlice;
